import { Form, Row, Col, Badge, Button, InputGroup } from 'react-bootstrap';
import icSearch from './assets/img/ic-magnifier.svg';
import countries from './data/countries'

const UserFilter = ({ 
    searchQuery, setSearchQuery, 
    selectedCountry, setSelectedCountry, 
    selectedCity, setSelectedCity,
    selectedRole, setSelectedRole,
    selectedCompany, setSelectedCompany,
    users,
}) => {
    
    const countryCodeToName = countries.reduce((acc, curr) => {
        acc[curr.id] = curr.name;
        return acc;
    }, {});

    const uniqueCountryCodes = [...new Set(users.map(user => user.country).filter(Boolean))].sort();

    const uniqueCountries = uniqueCountryCodes.map(code => ({
        code,
        name: countryCodeToName[code] || code
    }));

    const lowercasedQuery = searchQuery.toLowerCase();

    const usersMatchingQueryAndCountry = users.filter(user => {
        const matchesName = (
            (user.firstName && user.firstName.toLowerCase().includes(lowercasedQuery)) ||
            (user.familyName && user.familyName.toLowerCase().includes(lowercasedQuery))
        );

        const matchesCountry = !selectedCountry || user.country === selectedCountry;
        const matchesCity = !selectedCity || user.city === selectedCity;
        const matchesRole = !selectedRole || user.role === selectedRole;

        return matchesName && matchesCountry && matchesCity && matchesRole;
    });

    const uniqueCities = [...new Set(
        usersMatchingQueryAndCountry
            .map(user => user.city)
            .filter(Boolean)
    )].sort();

    const uniqueRoles = [...new Set(users.map(user => user.role).filter(Boolean))].sort();

    const uniqueCompanies = [...new Set(
        usersMatchingQueryAndCountry
            .filter(user => user.company && user.company.title)
            .map(user => user.company.title)
    )].sort();

    // Function to reset all filters
    const clearFilters = () => {
        setSearchQuery('');
        setSelectedCountry('');
        setSelectedCity('');
        setSelectedRole('');
        setSelectedCompany('');
    };

    return (
        <>
            {/* Filter Inputs */}
            <div className="filter">
                <div>
                    <div className="flex-grow-1">
                        <Row>
                            {/* Search by User Name */}
                            <Col md={2}>
                                <Form.Group controlId="searchUser">
                                    <Form.Label>Search</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                        type="text"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <InputGroup.Text>
                                            <img src={icSearch} alt="Search" />
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="searchCountry">
                                    <Form.Label>Country</Form.Label>
                                    <Form.Select
                                        value={selectedCountry}
                                        onChange={(e) => setSelectedCountry(e.target.value)}
                                    >
                                        <option value="">Filter by country...</option>
                                        {uniqueCountries.map((country, index) => (
                                            <option key={index} value={country.code}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="searchCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Select
                                        value={selectedCity}
                                        onChange={(e) => setSelectedCity(e.target.value)}
                                    >
                                        <option value="">Filter by city...</option>
                                        {uniqueCities.map((city, index) => (
                                            <option key={index} value={city}>
                                                {city}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group controlId="searchRole">
                                    <Form.Label>User Role</Form.Label>
                                    <Form.Select
                                        value={selectedRole}
                                        onChange={(e) => setSelectedRole(e.target.value)}
                                    >
                                        <option value="">Filter by role...</option>
                                        {uniqueRoles.map((role, index) => (
                                            <option key={index} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="searchCompany">
                                    <Form.Label>Company</Form.Label>
                                    <Form.Select
                                        value={selectedCompany}
                                        onChange={(e) => setSelectedCompany(e.target.value)}
                                    >
                                        <option value="">Filter by company...</option>
                                        {uniqueCompanies.map((company, index) => (
                                            <option key={index} value={company}>
                                                {company}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Button variant="primary" className="btn-sm">
                            Save Filters
                        </Button>
                    </div>
                </div>
                {/* Applied Filters Display */}
                {(searchQuery || selectedCountry || selectedCity || selectedRole || selectedCompany) && (
                     <>
                        <Row className="filter-results">
                            <Col className="d-flex align-items-center">
                                <span>Filters:</span>
                                {searchQuery && (
                                    <Badge bg="info" className="me-2">
                                        User: {searchQuery} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSearchQuery('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}

                                {selectedCountry && (
                                    <Badge bg="info" className="me-2">
                                        {selectedCountry} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSelectedCountry('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}

                                {selectedCity && (
                                    <Badge bg="info" className="me-2">
                                        {selectedCity} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSelectedCity('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}

                                {selectedRole && (
                                    <Badge bg="info" className="me-2">
                                        {selectedRole} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSelectedRole('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}

                                {selectedCompany && (
                                    <Badge bg="info" className="me-2">
                                        {selectedCompany} 
                                        <Button 
                                            variant="link" size="sm"
                                            onClick={() => setSelectedCompany('')}
                                        >
                                            ×
                                        </Button>
                                    </Badge>
                                )}
                                
                                {/* Clear All Filters Button */}
                                <Button variant="link" size="sm" className="ms-auto" onClick={clearFilters}>
                                    Clear All
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>

        </>
    );
};

export default UserFilter;
